import { WorkflowDroppedField } from '../workflow-dropped-field.class';
import { WorkflowContact } from '@app/core/class';
import { WORKFLOW_STEP_FIELDS } from '@app/core/services/workflow.enum';

export class EmailField extends WorkflowDroppedField {
  constructor(contact: WorkflowContact) {
    super(contact);
    this.type = WORKFLOW_STEP_FIELDS.TYPE_EMAIL_TEXT;
    this.minHeight = this.height = 25;
    this.minWidth = this.width = 150;
  }
}
